import { render, staticRenderFns } from "./UserNotificationShowDialog.vue?vue&type=template&id=78e4392c&"
import script from "./UserNotificationShowDialog.vue?vue&type=script&lang=js&"
export * from "./UserNotificationShowDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports